const Optimization_Timer_Label = {
  queuedLabel: 'Time in queue',
  runTimeLabel: 'Optimization run time'
};

const OTHER_ROUTE_TYPES = {
  EXTRATRLR: 'ExtraTrailerRoute',
  OVERCAPACITY: 'OverCapacityRoute',
  LATEWAVE: 'LateWaveRoute',
  EXTRA_ROUTE_NEEDED: 'EXTRA ROUTE NEEDED' // this is comming from backend api (getRoutes) in comment field
};

const OTHER_ROUTES_COMMENTS = {
  [OTHER_ROUTE_TYPES.EXTRATRLR]: 'Extra trailer required',
  [OTHER_ROUTE_TYPES.OVERCAPACITY]: 'Over Capacity',
  [OTHER_ROUTE_TYPES.EXTRA_ROUTE_NEEDED]: 'Extra route needed'
};

const inputFields = {
  trailerTypeCountList: "trailerTypeCountList",
  maxStopsPerRoute: "maxStopsPerRouteCount",
  maxNumberOfTrips: "maxNumberOfTripsCount",
  lastWaveCutOff: "lastWaveCutOff",
  isReturnToTerminal: "isReturnToTerminal",
  isMergeExtraRoutes: "isMergeExtraRoutes",
  mergedExtraRouteName: "mergedExtraRouteName"
};

const SINGLE_SELECTED_ROUTE_COUNT = 1;

// Terminal parameter CreateFinalMileRoute (Engine + Linkex secondary-route UI on LXC)
const CREATE_FINAL_MILE_ROUTE_PARAMETER = {
  name: 'CreateFinalMileRoute',
  enabledValue: '1',
  fallbackValue: '0'
};

export {
  Optimization_Timer_Label,
  OTHER_ROUTE_TYPES,
  OTHER_ROUTES_COMMENTS,
  inputFields,
  SINGLE_SELECTED_ROUTE_COUNT,
  CREATE_FINAL_MILE_ROUTE_PARAMETER
};
